import { render, staticRenderFns } from "./BasicFeeAndLearningMaterialForm.vue?vue&type=template&id=38afa616"
import script from "./BasicFeeAndLearningMaterialForm.vue?vue&type=script&lang=ts"
export * from "./BasicFeeAndLearningMaterialForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports